import { applicationSettings } from '../../../settings/application';
import { RANGES } from '../../../constants';
import BROR from './ranges/BROR';

const ranges = { [RANGES.BROR]: BROR };

/**
 * As a general rule, this function will need no manipulation. Yes, I know, bold claim,
 * but bare with me! This one simply runs other functions and if such exist for the given
 * range, and makes sure that they returns arrays, simple as that!
 *
 * Any manipulation goes in ranges and middlewares folder. The concept is, we have loosely
 * coupled middleware functions, stored in the "middlewares"-folder that we use to combine
 * for a given range in the ranges folder. The ranges files should ALWAYS return an array
 * including prepped functions ready to run.
 *
 * @param items
 * @returns {*}
 */
export const tacMiddleware = items => {
  return ranges?.[applicationSettings.applicationName]
    ? ranges[applicationSettings.applicationName].reduce((acc, curr) => {
        const itemsArray = curr(acc);

        if (!Array.isArray(itemsArray))
          throw new Error(
            'Did not return array. Items thingy functions must return one array'
          );

        return itemsArray;
      }, items)
    : items;
};
